import React from 'react';

import { RowProps } from '../types.js';
import { Row as RowComponent } from './Row.js';

const genericMemo: <T>(
  component: T,
  propsAreEqual?: (prevProps: Readonly<RowProps<T>>, nextProps: Readonly<RowProps<T>>) => boolean,
) => T = React.memo;

export const MemoizedRow = genericMemo(RowComponent, (prevProps, nextProps) => {
  const areIDsEqual = prevProps.row.id === nextProps.row.id;
  const rowIndex = prevProps.row.index;

  return prevProps.isSelected === null
    ? areIDsEqual
    : areIDsEqual &&
        prevProps.isSelected === nextProps.isSelected &&
        rowIndex !== nextProps.activeRowIndex &&
        rowIndex !== prevProps.activeRowIndex;
});
